import React from 'react'
import styles from './Login.module.scss'
import { useForm, FormProvider, useWatch } from 'react-hook-form'
import { useNavigate, useLocation } from 'react-router-dom'
import { InputField } from '../../components/fields/InputField/InputField'
import ValidationMap from '../signup/FirstSignup/components/BasicField/ValidationMap'
import { ExclamationCircleIcon } from '@heroicons/react/24/solid'
import { signin, getPreferredContractInfo } from '../../services/api'
import { useAuthStatus } from '../../utils'
import { useUser } from '../../hooks'

export const Login = () => {
	const [auth, handleLogout, setAuth] = useAuthStatus()
	const { refetch: refetchUser } = useUser()
	const methods = useForm()
	const navigate = useNavigate()
	const location = useLocation()

	// 리다이렉트 경로 가져오기 (state에서 from 경로 추출)
	const from = location.state?.from || '/home'

	// esLint 해결

	const {
		handleSubmit,
		register,
		formState: { errors },
		setError,
		clearErrors,
	} = methods

	const onSubmit = async (data) => {
		let response
		try {
			// 1. 로그인 API 호출
			response = await signin(data.email, data.password)
			console.log('signin response:', response)
		} catch (err) {
			console.log('err:', err)
			setError('root.server', {
				type: 'server',
				message: '로그인 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요',
			})
			return
		}

		const { token, user, success, message } = response || {}

		if (success === false) {
			setError('root.server', {
				type: 'server',
				message: message,
			})
			return
		} else if (!token || !user) {
			setError('root.server', {
				type: 'server',
				message: '로그인 중 오류가 발생했습니다. 잠시 후 다시 시도해주세요',
			})
			return
		}

		// 2. Context 저장
		setAuth(token, user)

		// 3. 선호계약 조회
		let preferredContract
		try {
			preferredContract = await getPreferredContractInfo(token)
		} catch (err) {
			if (err.response?.status === 404) {
				// 404는 선호계약이 없는 정상 케이스로 처리
				preferredContract = {
					domesticContract: null,
					overseasContract: null,
				}
			} else {
				console.error('선호계약 조회 실패:', err)
				// 선호계약 조회 실패시 기본 페이지로 이동
				return
			}
		}

		// 4. 리다이렉트 로직
		const hasNoPreferredContract =
			preferredContract.domesticContract === null &&
			preferredContract.overseasContract === null

		if (hasNoPreferredContract) {
			const onboardingPath =
				user.userType === 'tourPro'
					? '/onboarding/select-tournament'
					: '/onboarding/caddie-domestic'
			navigate(onboardingPath)
		} else {
			navigate(from, { replace: true })
		}
	}

	const requiredFields = ['email', 'password']

	const watchedAll = useWatch({
		control: methods.control,
		name: requiredFields,
	})

	return (
		<FormProvider {...methods}>
			<form onSubmit={handleSubmit(onSubmit)} className={styles.form}>
				<div className={styles.loginViewWrapper}>
					<span className={styles.title}>로그인</span>
					<div className={styles.loginBox}>
						{errors.root?.server && (
							<div className={styles.errorBanner}>
								<ExclamationCircleIcon
									style={{ width: '18px', height: '18px', color: '#ff5d5d' }}
								/>
								<span>{errors.root.server.message}</span>
							</div>
						)}
						<InputField
							name="email"
							label="이메일 계정"
							placeholder="이메일을 입력해주세요"
							validation={ValidationMap.email}
						/>
						<InputField
							name="password"
							label="비밀번호"
							placeholder="비밀번호를 입력해주세요"
							validation={ValidationMap.password}
						/>
						<button
							type="submit"
							className={styles.submitBtn}
							style={{
								backgroundColor: watchedAll.every(Boolean) ? '#1b1b1b' : '#e4e4e4',
							}}
							disabled={!watchedAll.every(Boolean)}
							onClick={handleSubmit(onSubmit)}>
							로그인
						</button>

						<div className={styles.linkBox}>
							<a href="/auth/find-credentials" className={styles.find}>
								계정/비밀번호 찾기
							</a>
							<a href="/signup" className={styles.signup}>
								회원가입
							</a>
						</div>
					</div>
				</div>
			</form>
		</FormProvider>
	)
}
